import http from '../../../utils/services/http'

export const newEnvolvido = (data) => {
  let url = `/api/processos/envolvidos`
  return http.post(url, data)
      .then(response => {
        return Promise.resolve(response)
      })
      .catch(({response}) => {
        return Promise.reject(response)
      })
}

export const updateEnvolvido = (id, data) => {
    let url = `/api/processos/envolvidos/${id}`
    return http.put(url, data)
        .then(response => {
            return Promise.resolve(response)
        })
        .catch(({response}) => {
            return Promise.reject(response)
        })
}

export const find = (id) => {
  let url = `/api/processos/envolvidos/${id}`
  return http.get(url)
    .then(response => {
      return Promise.resolve(response)
    })
    .catch(({response}) => {
      return Promise.reject(response)
    })
}
